<template>
    <v-row>
<!--      <div style="display: flex">-->
        <v-col cols="6">
            <v-card class="total-report-card">
                <v-card-title>
                    <div class="report-title">
                        <v-icon color="white">mdi-cash-multiple</v-icon>
                        Doanh thu
                    </div>
                </v-card-title>
                <v-card-text v-if="!_.isEmpty(dataRevenue)">

<!--                    <div style="text-align: right">-->
<!--                      <v-tooltip bottom>-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                          <v-btn icon small color="black" v-on="on">-->
<!--                            <v-icon>mdi-calendar</v-icon>-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                        <span>Tìm kiếm theo thời gian</span>-->
<!--                      </v-tooltip>-->
<!--                    </div>-->


                  <v-row>
<!--                      <v-col cols="12" md="6"></v-col>-->

                      <v-col
                          cols="12"
                          md="12"
                      >
                        <common-range-picker
                            :aLight="'left'"
                            label="Tìm kiếm theo thời gian"
                            :defaultRange="defaultRange"
                            @change-date-range="changeDateRange"
                            clearable
                        />
                      </v-col>
                  </v-row>


                    <div class="total-wrapper">
                        <v-row>
                            <v-col cols="2" class="text-left">
                                <b>Số đơn</b>
                            </v-col>
                            <v-col cols="10" class="text-left total-value">
                                {{ formatPrice(parseFloat(_.get(dataRevenue, 'totalSuccessOrderByDate', 0))) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right pt-0 pb-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <span class="total-sub-value" v-on="on">
                                            {{ formatPrice(parseFloat(_.get(dataRevenue, 'totalSuccessOrderByAcc', 0))) }}
                                        </span>
                                    </template>
                                    <span>Số đơn</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="total-wrapper">
                        <v-row class="mt-2">
                            <v-col cols="2" class="text-left">
                                <b>Doanh thu</b>
                            </v-col>
                            <v-col cols="10" class="text-left total-value">
                                {{ formatPrice(_.get(dataRevenue, 'totalRevenueByDate', '0.00')) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right pt-0 pb-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <span class="total-sub-value" v-on="on">
                                            {{ formatPrice(_.get(dataRevenue, 'totalRevenueByAcc', '0.00')) }}
                                        </span>
                                    </template>
                                    <span>Doanh thu</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="total-wrapper">
                        <v-row class="mt-2">
                            <v-col cols="2" class="text-left">
                                <b>Hoa hồng</b>
                            </v-col>
                            <v-col cols="10" class="text-left total-value">
                                {{ formatPrice(Math.round(parseFloat(_.get(dataRevenue, 'roseByDate', '0.00')))) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right pt-0 pb-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <span class="total-sub-value" v-on="on">
                                            {{ formatPrice(Math.round(parseFloat(_.get(dataRevenue, 'roseByAcc', '0.00')))) }}
                                        </span>
                                    </template>
                                    <span>Hoa hồng</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-text v-else>
                    <common-no-result />
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="6">
            <v-card class="mb-0" style="height: calc(100% - 30px)">
                <v-card-title>
                    <div class="report-title">
                        <v-icon color="white">mdi-cash-multiple</v-icon>
                        Thu nhập
                    </div>
                </v-card-title>
                <v-card-text class="report-content-wrapper">
                  <div
                      class="earning-container text-center"
                      >
                    <div class="count-label">
                      Hoa hồng đang có
                    </div>
                    <div class="text-center number-wrapper">
                      <div class="count-number-item">
                        {{ formatPrice(_.get(dataEarning, 'roseCurrent', 0)) }}
                      </div>
                    </div>
                  </div>

                  <div
                      class="earning-container text-center"
                  >
                    <div class="count-label">
                      Thưởng đang có
                    </div>
                    <div class="text-center number-wrapper">
                      <div class="count-number-item">
                        {{ formatPrice(_.get(dataEarning, 'bonusCurrent', 0)) }}
                      </div>
                    </div>
                  </div>
                </v-card-text>
              <div class="policy-ctv icon-pointer">
                <a href="/partner/policy-partner">Chính sách CTV</a>
              </div>
            </v-card>
        </v-col>
<!--      </div>-->

        <v-col cols="12">
        <v-card class="mb-0">
          <v-card-title>
            <div class="report-title">
              <v-icon color="white">mdi-cash-usd</v-icon>
              Giao dịch
            </div>
          </v-card-title>
          <v-card-text>
            <div class="total-wrapper-transaction">
              <v-row style="align-items: center">
                <v-col cols="12" md="6" class="text-left py-0 total-sub-text">
                  Thanh toán trong kỳ tới
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                >

                  <v-menu
                      ref="menu_month"
                      :close-on-content-click="false"
                      :return-value.sync="selectMonth"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="selectMonth"
                          label="Chọn tháng"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="selectMonth" no-title scrollable @change="changeDateRangeTransaction" type="month">
                    </v-date-picker>
                  </v-menu>

                </v-col>
              </v-row>
            </div>
<!--            <v-row>-->
<!--              <v-col-->
<!--                  cols="12"-->
<!--                  md="12"-->
<!--              >-->

<!--                <v-menu-->
<!--                    ref="menu_month"-->
<!--                    :close-on-content-click="false"-->
<!--                    :return-value.sync="selectMonth"-->
<!--                    transition="scale-transition"-->
<!--                    offset-y-->
<!--                    min-width="290px">-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <v-text-field-->
<!--                        v-model="selectMonth"-->
<!--                        label="Chọn tháng"-->
<!--                        prepend-icon="mdi-calendar"-->
<!--                        readonly-->
<!--                        v-on="on"-->
<!--                    ></v-text-field>-->
<!--                  </template>-->
<!--                  <v-date-picker v-model="selectMonth" no-title scrollable @change="changeDateRangeTransaction" type="month">-->
<!--                  </v-date-picker>-->
<!--                </v-menu>-->

<!--              </v-col>-->
<!--            </v-row>-->
              <v-card-text style="display: flex; justify-content: center; align-items: center">
                <div
                    class="earning-container text-center cart-text-transaction-item"
                >
                  <div class="count-label">
                    Hoa hồng thanh toán
                  </div>
                  <div class="text-center number-wrapper transaction">
                    <div class="count-number-item">
                      {{ formatPrice(_.get(dataTransaction, 'roseInTerm', 0)) }}
                    </div>
                  </div>
                </div>


                <div
                    class="earning-container text-center col-sm-1"
                >
                  <div class="count-label">

                  </div>
                  <div class="text-center">
                    <div class="earning-container">
                      <span class="operator-character">+</span>
                    </div>
                  </div>
                </div>



                <div
                    class="earning-container text-center cart-text-transaction-item"
                >
                  <div class="count-label">
                    Thưởng trong kỳ
                  </div>
                  <div class="text-center number-wrapper transaction">
                    <div class="count-number-item">
                      {{ formatPrice(_.get(dataTransaction, 'bonusInTerm', 0)) }}
                    </div>
                  </div>
                </div>


<!--                <div-->
<!--                    class="earning-container text-center col-sm-1"-->
<!--                >-->
<!--                  <div class="count-label">-->

<!--                  </div>-->
<!--                  <div class="text-center">-->
<!--                    <div class="earning-container">-->
<!--                      <span class="operator-character">-</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->


<!--                <div-->
<!--                    class="earning-container text-center cart-text-transaction-item"-->
<!--                >-->
<!--                  <div class="count-label">-->
<!--                    Thuế thu nhập cá nhân-->
<!--                  </div>-->
<!--                  <div class="text-center number-wrapper transaction">-->
<!--                    <div class="count-number-item">-->
<!--                      {{ formatPrice(_.get(dataTransaction, 'tax', 0)) }}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

                <div
                    class="earning-container text-center col-sm-1"
                >
                  <div class="count-label">

                  </div>
                  <div class="text-center">
                    <div class="earning-container">
                      <span class="operator-character">=</span>
                    </div>
                  </div>
                </div>

                <div
                    class="earning-container text-center cart-text-transaction-item"
                >
                  <div class="count-label">
                    Thanh toán trước thuế
                  </div>
                  <div class="text-center number-wrapper transaction received">
                    <div class="count-number-item">
                      {{ formatPrice(_.get(dataTransaction, 'receivedCash', 0)) }}
                    </div>
                  </div>
                </div>
              </v-card-text>
          </v-card-text>
<!--          <div class="policy-ctv icon-pointer" style="margin-bottom: 16px">-->
<!--            <a href="/partner/transaction-history">Lịch sử giao dịch</a>-->
<!--          </div>-->
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import * as moment from "moment";

export default {
    props: {
      dataRevenue: {
        type: Object,
        default: () => {}
      },
      dataEarning: {
        type: Object,
        default: () => {}
      },
      dataTransaction: {
        type: Object,
        default: () => {}
      },
      filterForm: {
        default: () => ({})
      },
      filterFormTransaction: {
        default: () => ({})
      }
    },
    data () {
      return {
        defaultRange: {
          startDate: moment().startOf('month').format('YYYY-MM-DD'),
          endDate: moment().endOf('month').format('YYYY-MM-DD'),
        },
        selectRange: [{
          startDate: moment().startOf('month').format('YYYY-MM-DD'),
          endDate: moment().endOf('month').format('YYYY-MM-DD'),
        }],
        selectMonth: moment().format('YYYY-MM'),
        datePicker: false
      }
    },
    methods: {
      changeDateRange (dateRange) {
        this.filterForm.dateRange = dateRange
        this.selectRange = dateRange
        Bus.$emit('revenue-report-list-filter', this.filterForm)
      },
      changeDateRangeTransaction() {
        this.$refs.menu_month.save(this.selectMonth)
        this.datePicker = false
        this.filterFormTransaction.month = this.selectMonth
        Bus.$emit('transaction-report-list-filter', this.filterFormTransaction)
      }
    }
}
</script>

<style scoped>
.v-card {
    overflow: visible !important;
    overflow-x: hidden;
}

.sticky-total-card {
    position: sticky;
    top: 40px;
}

.total-report-card {
    margin-bottom: 0px !important;
    height: calc(100% - 30px) !important;
}

.total-wrapper {
    margin-top: 3%;
    border-bottom: thin solid #e2e2e2;
}

.total-wrapper-transaction {
    padding-bottom: 10px !important;
}

.report-title {
    position: absolute;
    top: -30px;
    background-color: #e91e63;
    padding: 5px 20px;
    color: white;
    border-radius: 5px;
}

.total-value {
    /*font-size: 36px;*/
    font-weight: 500;
}

.total-sub-text {
    color: #979797;
    font-weight: 400;
    height: fit-content;
    border-bottom: thin solid #e2e2e2;
    padding-bottom: 10px !important;
    text-transform: uppercase;
}

.total-sub-value {
    color: #000000;
    background-color: #aaaaaa;
    padding: 2px 20px;
    border-radius: 10px;
}

table tbody tr {
    height: 40px !important;
    padding: 0px;
}

table thead th {
    font-weight: bold;
}

table tbody td {
    font-weight: 500;
}

table tbody tr.header-tr {
    background-color: rgba(0, 0, 0, 0.11) !important;
}

table tbody tr.header-tr td {
    font-size: 16px;
}
.count-number-item {
  font-size: 26px;
  font-weight: 400;
}
.number-wrapper {
  border: 3px solid #495057;
  border-radius: 50px;
  padding: 13px 0px;
  margin: auto;
  width: 50%;
}
.number-wrapper.transaction, .report-content-wrapper div.earning-container {
  width: 100% !important;
}
.earning-container {
  margin-top: 30px;
}
.count-label {
  margin-bottom: 10px;
}
.policy-ctv {
  width: 100%;
  display: inline-block;
  text-align: right;
  padding-right: 25px;
}
.policy-ctv a {
  color: gray !important;
}
.operator-character {
  font-size: 50px;
  color: #495057;
}
.cart-text-transaction-item {
  width: 23%;
}
.report-content-wrapper {
  height: 88%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.number-wrapper.transaction.received {
  border: 3px solid #e91e63 !important;
  color: #e91e63;
}
</style>